// 1. if you want your component code to be testable, it is best to use a route resolver and make the connection there
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { SignalR, SignalRConfiguration, SignalRConnection } from 'ng2-signalr';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { ApiUrlService } from './../../api/services/api-url.service';
import { AuthState } from './../../auth/store/auth.entity';

@Injectable()
export class ConnectionResolver implements Resolve<SignalRConnection> {
    c = new SignalRConfiguration();

    constructor(private _signalR: SignalR, private store: Store<AuthState>, private urlService:ApiUrlService)  {
        this.c.hubName = 'reportnotificationhub';
        this.c.url = this.urlService.getApiEndpointUrl(environment.defaultApiEndpoint);
        this.c.executeEventsInZone = true; // optional, default is true
        this.c.executeErrorsInZone = false; // optional, default is false
        this.c.executeStatusChangeInZone = true; // optional, default is true
     }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): SignalRConnection | Observable<SignalRConnection> | Promise<SignalRConnection> | any {

    }
}
